import type { TicketStatus, TicketPriority } from "@shared/types";
import { useT } from "../../i18n/I18nProvider";

export function StatusBadge({ status }: { status: TicketStatus }) {
  const t = useT();
  return <span className={`badge status-${status}`}>{t(`status.${status}`)}</span>;
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  const t = useT();
  return <span className={`badge priority-${priority}`}>{t(`priority.${priority}`)}</span>;
}
